import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import {
    useLocation
} from "react-router-dom";
import { Button, Card, CardContent, Tooltip } from "@mui/material";
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid2';
import "./milestone.css";
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import TextInput from "../common/TextInput";
import SelectDropdown from "../common/FormSelectDropdown";
import DateCalendarValue from "../common/Calander/Calander";
import { yupResolver } from "@hookform/resolvers/yup";
import { useLoader } from "../../../pages/LoaderContext";
import { successToast, errorToast } from "../../utils/toast";
import { ToastContainer } from 'react-toastify';
import UnSavedModal from "../common/UnSavedModal"
import ValidationModal from "../common/ValidationModal"
import { useAppContext } from '../../../hooks/context/AppContext';
import { useApiClient } from "../../Services/api/mileStoneService"
import { useProjectApiClient } from "../../Services/api/projectService"
import AutoSaveModal from "../common/AutoSaveModal"
import useIdle from '../../../hooks/useIdle';
import FileUpload from "../common/FileUpload";
import UploadList from "../common/UploadsList";
import circleArrowIcon from "../../../assets/images/circle-arrow-icon.svg"
import uploadIcon from "../../../assets/images/upload-icon.svg";


import { useNavigate, useParams } from "react-router-dom";
import { projectVersion } from "config/navConfig";

const useStyles = makeStyles({
    themeButton: {
        backgroundColor: '#2a3fbf !important',
        padding: "8px 30px",
        fontWeight: "700",
        '&:hover': { backgroundColor: '#2a3fbf !important' },
    },
    cancelButton: {
        backgroundColor: "#d9d9d9 !important",
        color: "#626262 !important",
        padding: "8px 30px",
        fontWeight: "700",
        '&:hover': { backgroundColor: '#d9d9d9 !important', color: '#626262 !important' },
    },
    cardFieldBg: {
        backgroundColor: "#f4f4f4 !important"
    }
});

interface AuditEntry {
    fieldName: string;
    oldValue: string;
    newValue: string;
}

const MileStone: React.FC = () => {
    const location = useLocation();

    const { projectId, projectKey } = useParams<{ projectKey: string; projectId: string }>();

    const {
        getRisk,
        getWeek,
        createMilestone,
        getMilestone,
        updateMilestone,
    } = useApiClient()
    const { getLaunchYears, getProjectDetails, getRequiredField, publishProjectOnSave, uploadProjectFile } = useProjectApiClient();

    const { appData, updateAppData, userData } = useAppContext();
    const classes = useStyles();
    const navigate = useNavigate();
    const [openCalendar, setOpenCalendar] = useState<string | null>(null);
    const [risks, setRisks] = useState([])
    const [isExisting, setIsExisting] = useState(false)
    const { setLoading } = useLoader();
    const [isDisabled, setIsDisabled] = useState(true);
    const [isLaunchYearDisabled, setIsLaunchYearDisabled] = useState(false);

    const [launchYears, setLaunchYears] = useState([])
    const [launchWeeks, setLaunchWeeks] = useState([])
    const [validationErrors, setValidationErrors] = useState({})
    const [isValidationError, setIsValidationError] = useState(false)

    const [isUpload, setIsUpload] = React.useState<boolean>(false);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const [projectDetails, setProjectDetails] = useState({
        issaved: false
    })
    const [isDraftDisabled, setIsDraftDisabled] = useState(false);
    const [autoSaveModal, setAutoSaveModal] = React.useState<boolean>(false);
    const isIdle = useIdle(60000 * 10)
    const hasAutoSaved = useRef(false);



    const [formData, setFormData] = useState({
        siw: '',
        launchYear: '',
        launchWeek: '',
        launchQuarter: '',
        productLockDate: '',
        productLockComment: '',
        bcSignDate: '',
        bcSignDateComment: '',
        mptProductComment: '',
        mptProductDate: '',
        firstProductionDate: '',
        firstProductionComment: '',
        risk: '',
        comment: '',
    })


    const [initialFormData, setInitialFormData] = useState({
        siw: '',
        launchYear: '',
        launchWeek: '',
        launchQuarter: '',
        productLockDate: '',
        productLockComment: '',
        bcSignDate: '',
        bcSignDateComment: '',
        mptProductComment: '',
        mptProductDate: '',
        firstProductionDate: '',
        firstProductionComment: '',
        risk: '',
        comment: '',
    })

    const schema = yup.object().shape({
        siw: yup.string(),
        launchYear: yup.string().required("Launch Year is required."),
        launchWeek: yup.string().required("Launch Week is required."),
        launchQuarter: yup.string(),
        // siwDate: yup.string().required("Siw is required."),
        productLockDate: yup.string(),
        productLockComment: yup.string().nullable(),
        bcSignDate: yup.string(),
        bcSignDateComment: yup.string().nullable(),
        mptProductDate: yup.string(),
        mptProductComment: yup.string().nullable(),
        firstProductionDate: yup.string(),
        firstProductionComment: yup.string().nullable(),
        comment: yup.string().nullable(),
        risk: yup.string(),

    });



    const {
        handleSubmit,
        control,
        clearErrors,
        setValue,
        reset,
        trigger,
        formState: { errors },
    } = useForm({
        defaultValues: {
            productLockDate: "",
            bcSignDate: "",
            mptProductDate: "",
            firstProductionDate: "",
        },
        // @ts-ignore
        resolver: yupResolver(schema),
    });

    useEffect(() => {
        // @ts-ignore
        reset(formData);
    }, [formData]);


    useEffect(() => {
        if (isIdle && !autoSaveModal) {
            let check = JSON.stringify(formData) === JSON.stringify(initialFormData);
            if (!check && !hasAutoSaved.current) {
                setAutoSaveModal(true);
            }
        }
    }, [isIdle]);


    useEffect(() => {
        if (userData) {
            setIsDisabled(!userData.permissions.CanEdit)
        }

    }, [userData]);



    useEffect(() => {
        let check = JSON.stringify(formData) === JSON.stringify(initialFormData);
        if (!check) {
            updateAppData({ isFormChanged: true, showUnSavedModal: false });
        } else {
            updateAppData({ isFormChanged: false, showUnSavedModal: false });
        }

    }, [formData]);


    useEffect(() => {
        setLoading(true)
        const fetchOptions = async () => {
            fetchRisk()
            fetchYears()
            // fetchWeeks()
        };
        fetchOptions()
        if (projectKey) {
            fetchsProjectDetails(projectKey)
        }

    }, [projectKey]);

    useEffect(() => {
        const fetchOptions = async () => {
            fetchWeeks()
        };
        fetchOptions()


    }, [formData.launchQuarter, formData.launchYear]);

    const fetchYears = async () => {
        try {
            const data = await getLaunchYears();
            let output = data.map((item: any) => ({
                key: item.launchYears_key,
                value: item.launchYears_value
            }));
            // @ts-ignore
            setLaunchYears(output)
        } catch (error) {
            console.error(" Failed to fetch projects:", error);
        } finally {
        }
    };

    let pubLishProjectData = async () => {
        let res = await publishProjectOnSave(projectKey)
        if (res && res.issaved !== undefined) {
            setProjectDetails({ issaved: res.issaved });
        }
    }

    const fetchWeeks = async () => {
        try {
            const data = await getWeek(formData.launchYear, formData.launchQuarter);
            //  console.log("data  weeekkk->", data.data)
            let output = data.data.map((item: any) => ({
                key: item.Launch_Week,
                value: item.Launch_WeekName
            }));
            // @ts-ignore
            setLaunchWeeks(output)
        } catch (error) {
            console.error(" Failed to fetch projects:", error);
        } finally {
        }
    };

    const fetchRisk = async () => {
        try {
            const data = await getRisk();
            let output = data.map((item: any) => ({
                key: item.Risk_key,
                value: item.Risk_name
            }));
            setRisks(output)
        } catch (error) {
            console.error(" Failed to fetch projects:", error);
        } finally {
        }
    };

    const isEmptyObject = (obj: object) => {
        return JSON.stringify(obj) === '{}'
    };

    const fetchsProjectDetails = async (projectKey: string) => {
        try {
            const data = await getProjectDetails(projectId);
            if (data) {
                setProjectDetails({ issaved: data.issaved })
                setIsDraftDisabled(data.issaved)
                fetchMilestoneDetails(projectKey, data)
            }

        } catch (error) {
            console.error(" Failed to fetch projects:", error);
        } finally {
        }
    };
    const fetchMilestoneDetails = async (key: string, projectData: any) => {

        try {
            const data = await getMilestone(key);
            const milestoneAttr = projectData.project_attributes?.find(
                (attr: any) => attr.toSaveMileStone
            );

            if (milestoneAttr?.Launch_Year) {
                setIsLaunchYearDisabled(true);
            }
            setLoading(false)
            if (!isEmptyObject(data.data)) {
                setIsExisting(true)
                let mileStoneData = {
                    siw: data.data.SIW ? data.data.SIW : '',
                    // siwDate: data.data.siw_date ? formatDate(data.data.siw_date) : '',
                    launchYear: projectData.project_attributes?.find((attr: any) => attr.toSaveMileStone)?.Launch_Year ? JSON.stringify(projectData.project_attributes?.find((attr: any) => attr.toSaveMileStone)?.Launch_Year) : '',
                    launchWeek: data.data.Launch_Week ? JSON.stringify(data.data.Launch_Week) : '',
                    launchQuarter: projectData.project_attributes?.find((attr: any) => attr.toSaveMileStone)?.Launch_Quarter ? JSON.stringify(projectData.project_attributes?.find((attr: any) => attr.toSaveMileStone)?.Launch_Quarter) : '',
                    productLockDate: data.data.Product_Lock_Date ? formatDate(data.data.Product_Lock_Date) : '',
                    productLockComment: data.data.Product_Lock,
                    bcSignDate: data.data.BCSignOff_CP_Date ? formatDate(data.data.BCSignOff_CP_Date) : '',
                    bcSignDateComment: data.data.BCSignOff_CP,
                    mptProductComment: data.data.MPTProductValidation,
                    mptProductDate: data.data.MPTProductValidation_Date ? formatDate(data.data.MPTProductValidation_Date) : '',
                    firstProductionDate: data.data.FirstProduction_Date ? formatDate(data.data.FirstProduction_Date) : '',
                    firstProductionComment: data.data.FirstProduction,
                    risk: JSON.stringify(data.data.Risk_Key),
                    comment: data.data.Comment,
                }
                setFormData(mileStoneData)
                setInitialFormData(mileStoneData)
            } else {
                let updatedData = {
                    ...initialFormData,
                    launchYear: projectData.project_attributes?.find((attr: any) => attr.toSaveMileStone)?.Launch_Year ? JSON.stringify(projectData.project_attributes?.find((attr: any) => attr.toSaveMileStone)?.Launch_Year) : '',
                    launchQuarter: projectData.project_attributes?.find((attr: any) => attr.toSaveMileStone)?.Launch_Quarter ? JSON.stringify(projectData.project_attributes?.find((attr: any) => attr.toSaveMileStone)?.Launch_Quarter) : ''
                }
                setFormData(updatedData)
                setInitialFormData(updatedData)

            }
        } catch (error) {
            console.error(" Failed to fetch projects:", error);
        } finally {

        }
    };
    const fetchRequiredField = async () => {
        try {
            const data = await getRequiredField(projectKey);
            return data
        } catch (error) {
            console.error(" Failed to fetch projects:", error);
        } finally {

        }
    };

    let groupByModule = (errors: any) => {
        return errors.reduce((grouped: any, error: any) => {
            const { ModuleName, Message } = error;
            if (!grouped[ModuleName]) {
                grouped[ModuleName] = [];
            }
            grouped[ModuleName].push(Message);
            return grouped;
        }, {});
    }

    const toggleCalendar = (calendarId: any) => {
        //   setIsCalendarOpen(!isCalendarOpen);
        setOpenCalendar((prev) => (prev === calendarId ? null : calendarId)); // Toggle calendar open/close

    };

    const handleDateSelect = (date: string, fieldName: string) => {
        {/* @ts-ignore */ }
        handleFormChange(fieldName, date?.format('DD-MM-YYYY')); const formattedDate = date?.format('DD-MM-YYYY'); setValue(fieldName, formattedDate);
        {/* @ts-ignore */ }
        trigger(fieldName);
        setOpenCalendar(null);
    };
    const toNullIfEmpty = (value: any) =>
        value === "null" || value === "undefined" || value === undefined || value === "" ? null : value;


    const getCompleteAuditTrail = (initialData: Record<string, any>, updatedData: Record<string, any>): AuditEntry[] => {
        const audit: AuditEntry[] = [];
        const keys = Object.keys(initialData);
        for (const key of keys) {
            if (key === 'project_id') continue;

            const oldValue = initialData[key];
            const newValue = updatedData[key];

            audit.push({
                fieldName: key,
                oldValue: String(oldValue),
                newValue: String(newValue)
            });
        }

        return audit;
    }

    const onSubmit = async (data: any, type: any, url: string) => {
        let resField = await fetchRequiredField()
        if (resField?.data && resField?.data.filter((val: any) => val.ModuleName !== 'Milestones').length) {
            const groupedErrors = groupByModule(resField?.data.filter((val: any) => val.ModuleName !== 'Milestones'));
            setValidationErrors(groupedErrors)
            setIsValidationError(true)
            return
        }
        setLoading(true)
        let payload = {
            "SIW": data.siw,
            "Product_Lock": data.productLockComment == null ? toNullIfEmpty(data.productLockComment) : data.productLockComment,
            "Product_Lock_Date": toNullIfEmpty(convertDateFormat(data.productLockDate)),
            "BCSignOff_CP": data.bcSignDateComment ? toNullIfEmpty(data.bcSignDateComment) : '',
            "BCSignOff_CP_Date": toNullIfEmpty(convertDateFormat(data.bcSignDate)),
            "MPTProductValidation": data.mptProductComment ? toNullIfEmpty(data.mptProductComment) : '',
            "MPTProductValidation_Date": toNullIfEmpty(convertDateFormat(data.mptProductDate)),
            "FirstProduction": data.firstProductionComment ? toNullIfEmpty(data.firstProductionComment) : '',
            "FirstProduction_Date": toNullIfEmpty(convertDateFormat(data.firstProductionDate)),
            "Comment": data.comment ? toNullIfEmpty(data.comment) : '',
            "Risk_Key": toNullIfEmpty(data.risk),
            "Launch_Year": toNullIfEmpty(data.launchYear),
            "Launch_Week": toNullIfEmpty(data.launchWeek)
        }

        let initialPayload = {
            "SIW": initialFormData.siw,
            "Product_Lock": initialFormData.productLockComment == null ? toNullIfEmpty(initialFormData.productLockComment) : initialFormData.productLockComment,
            "Product_Lock_Date": toNullIfEmpty(convertDateFormat(initialFormData.productLockDate)),
            "BCSignOff_CP": initialFormData.bcSignDateComment ? toNullIfEmpty(initialFormData.bcSignDateComment) : '',
            "BCSignOff_CP_Date": toNullIfEmpty(convertDateFormat(initialFormData.bcSignDate)),
            "MPTProductValidation": initialFormData.mptProductComment ? toNullIfEmpty(initialFormData.mptProductComment) : '',
            "MPTProductValidation_Date": toNullIfEmpty(convertDateFormat(initialFormData.mptProductDate)),
            "FirstProduction": initialFormData.firstProductionComment ? toNullIfEmpty(initialFormData.firstProductionComment) : '',
            "FirstProduction_Date": toNullIfEmpty(convertDateFormat(initialFormData.firstProductionDate)),
            "Comment": initialFormData.comment ? toNullIfEmpty(initialFormData.comment) : '',
            "Risk_Key": toNullIfEmpty(initialFormData.risk),
            "Launch_Year": toNullIfEmpty(initialFormData.launchYear),
            "Launch_Week": toNullIfEmpty(initialFormData.launchWeek)
        }

        const completeAuditTrail = getCompleteAuditTrail(initialPayload, payload);
        {/* @ts-ignore */ }
        payload.audit = completeAuditTrail;

        if (!isExisting) {
            {/* @ts-ignore */ }
            let res = await createMilestone(payload, projectKey)
            await pubLishProjectData();
            setProjectDetails({ issaved: true });
            setIsDraftDisabled(true)
            updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
            setLoading(false)
            if (res) {
                updateAppData({ isFormChanged: false, showUnSavedModal: false });
                setIsExisting(true)
                {/* @ts-ignore */ }
                successToast(res.message)
                setTimeout(() => {
                    navigate(url ? url : `${projectVersion}/project/milestones/${projectId}/${projectKey}`)
                }, 2000);

            }
        } else {
            {/* @ts-ignore */ }
            let res = await updateMilestone(payload, projectKey)
            await pubLishProjectData()
            setProjectDetails({ issaved: true });
            setIsDraftDisabled(true)
            updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
            setLoading(false)
            if (res) {
                if (projectKey) {
                    fetchsProjectDetails(projectKey)
                }
                updateAppData({ isFormChanged: false, showUnSavedModal: false });
                {/* @ts-ignore */ }
                successToast(res.message)
                setTimeout(() => {
                    navigate(url ? url : `${projectVersion}/project/milestones/${projectId}/${projectKey}`)
                }, 2000)
            }
        }
    }
    let saveDraft = async (url: string) => {
        setLoading(true)
        let payload = {
            "SIW": formData.siw,
            "Product_Lock": formData.productLockComment == null ? toNullIfEmpty(formData.productLockComment) : formData.productLockComment,
            "Product_Lock_Date": toNullIfEmpty(convertDateFormat(formData.productLockDate)),
            "BCSignOff_CP": formData.bcSignDateComment ? toNullIfEmpty(formData.bcSignDateComment) : '',
            "BCSignOff_CP_Date": toNullIfEmpty(convertDateFormat(formData.bcSignDate)),
            "MPTProductValidation": formData.mptProductComment ? toNullIfEmpty(formData.mptProductComment) : '',
            "MPTProductValidation_Date": toNullIfEmpty(convertDateFormat(formData.mptProductDate)),
            "FirstProduction": formData.firstProductionComment ? toNullIfEmpty(formData.firstProductionComment) : '',
            "FirstProduction_Date": toNullIfEmpty(convertDateFormat(formData.firstProductionDate)),
            "Comment": formData.comment ? toNullIfEmpty(formData.comment) : '',
            "Risk_Key": toNullIfEmpty(formData.risk),
            "Launch_Year": toNullIfEmpty(formData.launchYear),
            "Launch_Week": toNullIfEmpty(formData.launchWeek)
        }
        if (!isExisting) {
            {/* @ts-ignore */ }
            let res = await createMilestone(payload, projectKey)
            setLoading(false)
            if (res) {
                updateAppData({ isFormChanged: false, showUnSavedModal: false });
                setIsExisting(true)
                {/* @ts-ignore */ }
                successToast(res.message)
                setTimeout(() => {
                    navigate(url ? url : `${projectVersion}/project/bc-information/${projectId}/${projectKey}`)
                }, 2000);

            }
        } else {
            {/* @ts-ignore */ }
            let res = await updateMilestone(payload, projectKey)
            setLoading(false)
            if (res) {
                if (projectKey) {
                    fetchsProjectDetails(projectKey)
                }
                updateAppData({ isFormChanged: false, showUnSavedModal: false });
                {/* @ts-ignore */ }
                successToast(res.message)
                setTimeout(() => {
                    navigate(url ? url : `${projectVersion}/project/bc-information/${projectId}/${projectKey}`)
                }, 2000)
            }
        }
    }

    let convertDateFormat = (dateStr: String) => {
        if (!dateStr) return
        const [day, month, year] = dateStr.split('-');
        return `${year}-${month}-${day}`;
    }


    const handleFormSubmit = (type: any, url: string) => {
        return handleSubmit((data) => onSubmit(data, type, url));
    };

    let formatDate = (dateString: string) => {
        const date = new Date(dateString);
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const year = date.getUTCFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        return formattedDate
    }

    let closeUnSavedModal = () => {
        updateAppData({ isFormChanged: true, showUnSavedModal: false, url: '' });
    }
    let saveUnSavedModal = () => {
        handleFormSubmit(true, appData.url)()
    }
    let draftSavedModal = () => {
        updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
        //  handleFormSubmit(false, appData.url)()
        saveDraft(appData.url)
    }
    const discardModal = () => {
        // reset form, redirect, or just close modal
        updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
        navigate(appData.url);
    };
    let handleCancel = () => {
        if (!appData.isFormChanged) {
            navigate(`${projectVersion}/projects-grid`)
        } else {
            updateAppData({ isFormChanged: true, showUnSavedModal: true });
        }

    }

    let handleFormChange = (name: any, value: any) => {
        setFormData({
            ...formData,
            [name]: value
        })
        hasAutoSaved.current = false
    }
    let closeValidationModal = () => {
        setIsValidationError(false)
        setValidationErrors({})
    }


    const autoSave = async () => {
        setAutoSaveModal(false);
        try {
            let resField = await fetchRequiredField()
            if (resField?.data && resField?.data.length) {
                await saveDraft('');
                hasAutoSaved.current = true;
            } else {
                await handleFormSubmit(true, '')();
                hasAutoSaved.current = true;
            }
        } catch (error) {
            console.error("Auto-save failed:", error);
        }
    };

    let closeAutoSave = () => {
        setAutoSaveModal(false)
    }

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const uploadFlag = searchParams.get("isUpload") === "true";
        if (uploadFlag) {
            setIsUpload(true);
            searchParams.delete("isUpload");
        }
    }, [location.search, location.pathname]);

    let handlebackUpload = () => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.delete("isUpload");

        navigate(
            {
                pathname: location.pathname,
                search: searchParams.toString()
                    ? `?${searchParams.toString()}`
                    : "", // no query string if empty
            },
            { replace: true }
        );

        setIsUpload(false);
    };

    const handleProjectFileChange = async (file: any) => {
        const allowedTypes = [
            'application/pdf',
            'application/msword',                       // .doc
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
            'application/vnd.ms-excel',                 // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',       // .xlsx
            'application/vnd.ms-powerpoint',            // .ppt
            'application/vnd.openxmlformats-officedocument.presentationml.presentation' // .pptx
        ];
        if (!allowedTypes.includes(file.type)) {
            errorToast('Only PDF, PPT, XLS or DOC formats are allowed.');
            return;
        }
        setLoading(true)
        const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB in bytes
        if (file.size > MAX_FILE_SIZE) {
            errorToast('File size must be less than 5 MB');
            return;
        }
        try {
            const formdata = new FormData();
            formdata.append("file", file, file.name);
            let data = await uploadProjectFile(projectKey, 2, formdata);
            //  successToast(data.message)
            setLoading(false)
            setRefreshTrigger(prev => prev + 1);

        } catch (error) {
            console.error('Error uploading file:', error);
            errorToast('Failed to upload file. Please try again.');
        }
    };

    let handleClickUpload = () => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set("isUpload", "true");

        navigate(
            {
                pathname: location.pathname,
                search: `?${searchParams.toString()}`,
            },
            { replace: true }
        );
        setIsUpload(true);
    };

    return (
        <>
            <ToastContainer />
            <div className="create-project-content">
                <Card className="" sx={{ padding: "10px", overflow: "inherit" }}>
                    <CardContent>
                        <div className="button-top-form" style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <>
                                {
                                    isUpload ?
                                        <Stack

                                            direction="row"
                                            spacing={2}
                                            sx={{ justifyContent: "start" }}
                                        >
                                            <Button onClick={() => handlebackUpload()} sx={{ border: '0px', fontSize: '14px', color: '#B5B5B5', p: 0, textTransform: 'capitalize' }}><img src={circleArrowIcon} className="wtsback--img" /></Button>

                                        </Stack>
                                        :
                                        <Stack

                                            direction="row"
                                            spacing={2}
                                            sx={{ justifyContent: "start" }}
                                        >

                                        </Stack>

                                }

                            </>
                            {
                                !isUpload ?
                                    <Stack
                                        direction="row"
                                        spacing={2}
                                        sx={{ justifyContent: "end", pb: 4 }}
                                    >
                                        {
                                            localStorage.user_info && JSON.parse(localStorage.user_info).Role !== '' ?
                                                JSON.parse(localStorage.user_info).Role !== 'ProjectViewer' ?
                                                    <Tooltip title="Upload Documents" arrow>
                                                        <Button
                                                            onClick={() => handleClickUpload()}
                                                            sx={{ p: 0, minWidth: 'auto', width: '38px', height: '38px', border: '1px solid #000', borderRadius: '50%' }}
                                                        >
                                                            <img src={uploadIcon} className="icon-wt-uplad" />
                                                        </Button>
                                                    </Tooltip>
                                                    :
                                                    <>
                                                    </>
                                                :
                                                null
                                        }
                                        <Button disabled={isDisabled} onClick={handleFormSubmit(true, '')} variant="contained"
                                            sx={{ borderRadius: '30px', px: 4, py: 1, textTransform: 'capitalize', color: 'white !important', backgroundColor: `${isDisabled ? '#d9d9d9 !important' : '#2a3fbf !important'}` }} className={classes.themeButton}>Submit</Button>

                                        <Button
                                            disabled={isDisabled || projectDetails.issaved}
                                            onClick={() => saveDraft('')}
                                            variant="contained"
                                            sx={{
                                                borderRadius: '30px',
                                                px: 4,
                                                py: 1,
                                                textTransform: 'capitalize',
                                                color: 'white !important',
                                                backgroundColor: '#2a3fbf !important',
                                                '&.Mui-disabled': {
                                                    backgroundColor: '#d9d9d9 !important',
                                                    color: '#5f6368 !important'
                                                }
                                            }}
                                            className={classes.themeButton}
                                        >
                                            Draft & Continue
                                        </Button>
                                        <Button disabled={isDisabled} onClick={handleCancel} variant="contained" sx={{ borderRadius: '30px', px: 4, py: 1, textTransform: 'capitalize' }} className={classes.cancelButton}>Cancel</Button>
                                    </Stack>
                                    :
                                    <>
                                        <div className="file-upload-button">
                                            <FileUpload isProjectUpload={true} isDisabled={false} onFileChange={handleProjectFileChange}
                                                name="uploadPic" label="Browse" control={control} errors={errors} />
                                        </div>
                                    </>
                            }

                        </div>
                        <Grid size={12}>
                            {
                                !isUpload ?
                                    <h5 className="txt-mandatory-title">*Fields are mandatory</h5>
                                    :
                                    null
                            }

                        </Grid>
                        <br></br>
                        {
                            isUpload ?
                                <>
                                    {/* @ts-ignore */}
                                    <UploadList refreshTrigger={refreshTrigger} setLoading={setLoading} moduleId={2}></UploadList>
                                </>
                                :
                                <form noValidate>
                                    <Grid container spacing={2}>
                                        <Grid size={{ xs: 12 }}>
                                            <Card sx={{ p: 2, boxShadow: 0, borderRadius: '10px', overflow: "visible" }} className={classes.cardFieldBg}>
                                                <h5 className="title-vt-prodt">SIW<span style={{ color: 'red' }}>*</span></h5>
                                                <Grid container spacing={2}>

                                                    <Grid size={{ xs: 12, md: 3 }}>
                                                        <Grid size={{ xs: 12, md: 12 }}>
                                                            <label className="txt-label-input">Launch Year<span className="required-txt">*</span></label>
                                                            <div className="project_drpdnw">
                                                                <Controller
                                                                    name="launchYear"
                                                                    control={control}
                                                                    render={({ field }) => (
                                                                        <SelectDropdown
                                                                            filterKey=""
                                                                            isDisabled={isDisabled || isLaunchYearDisabled}
                                                                            label=""
                                                                            value={field.value}
                                                                            onChange={(val) => {
                                                                                field.onChange(val);
                                                                                handleFormChange("launchYear", val);
                                                                                clearErrors("launchYear");
                                                                            }}
                                                                            options={launchYears}
                                                                            isError={errors.launchYear ? true : false}

                                                                        />
                                                                    )}
                                                                />
                                                            </div>
                                                            {errors.launchYear && <p className="error-message">{errors.launchYear.message}</p>}


                                                        </Grid>
                                                        <br></br>
                                                        <Grid size={{ xs: 12, md: 12 }}>
                                                            <label className="txt-label-input">Launch Week<span className="required-txt">*</span></label>
                                                            <div className="project_drpdnw">
                                                                <Controller
                                                                    name="launchWeek"
                                                                    control={control}
                                                                    render={({ field }) => (
                                                                        <SelectDropdown
                                                                            filterKey=""
                                                                            isDisabled={isDisabled}
                                                                            label=""
                                                                            value={field.value}
                                                                            onChange={(val) => {
                                                                                field.onChange(val);
                                                                                handleFormChange("launchWeek", val);
                                                                                clearErrors("launchWeek");
                                                                            }}
                                                                            options={launchWeeks}
                                                                            isError={errors.launchWeek ? true : false}

                                                                        />
                                                                    )}
                                                                />
                                                            </div>
                                                            {errors.launchWeek && <p className="error-message">{errors.launchWeek.message}</p>}

                                                        </Grid>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, md: 9 }}>
                                                        <div className="field-wap">
                                                            <label className="txt-label-input">Comment </label>
                                                            <Box sx={{ maxWidth: '100%' }}>
                                                                <TextInput isDisabled={isDisabled} isComment={true} className="siw-input" onChange={(e) => handleFormChange(e.target.name, e.target.value)} name="siw" label="" control={control} errors={errors} multiline />

                                                            </Box>
                                                        </div>
                                                    </Grid>
                                                </Grid>


                                            </Card>
                                        </Grid>
                                        <Grid size={{ xs: 12, md: 6 }}>
                                            <Card sx={{ p: 2, boxShadow: 0, borderRadius: '10px', overflow: "visible" }} className={classes.cardFieldBg}>
                                                <h5 className="title-vt-prodt">Product Lock</h5>
                                                <div className="field-wap">
                                                    <label className="txt-label-input">Select Date </label>
                                                    <div className="date-relative-card">
                                                        <Box sx={{ maxWidth: '50%', mb: 2, position: "relative" }}>
                                                            <Controller
                                                                name="productLockDate"
                                                                control={control}
                                                                render={({ field, fieldState: { error } }) => (
                                                                    <TextField
                                                                        {...field}
                                                                        fullWidth
                                                                        label=""
                                                                        id=""
                                                                        sx={{ input: { backgroundColor: '#fff', borderRadius: "20px" } }}
                                                                        onKeyDown={(e) => e.preventDefault()}
                                                                        error={!!error}
                                                                        helperText={error ? error.message : ""}
                                                                    // onChange={(e) => console.log("chn->", e.target)}
                                                                    />
                                                                )}
                                                            />
                                                            <span className={`icon-date ${isDisabled ? 'disabled' : ''}`} onClick={() => toggleCalendar("productLockDate")}>
                                                                <i className="fas fa-calendar-alt"></i>
                                                            </span>
                                                            {/* @ts-ignore */}
                                                            {openCalendar === "productLockDate" && (<DateCalendarValue dateValue={formData.productLockDate} onDateSelect={(date) => handleDateSelect(date, "productLockDate")} onClose={() => setOpenCalendar(null)} />)}
                                                        </Box>
                                                    </div>
                                                </div>
                                                <div className="field-wap">
                                                    <label className="txt-label-input">Comment </label>
                                                    <Box sx={{ maxWidth: '100%' }}>
                                                        <TextInput isDisabled={isDisabled} isComment={{ enabled: true, maxLength: 500 }} className="comment-input" onChange={(e) => handleFormChange(e.target.name, e.target.value)} name="productLockComment" label="" control={control} errors={errors} multiline />
                                                    </Box>
                                                </div>
                                            </Card>
                                        </Grid>
                                        <Grid size={{ xs: 12, md: 6 }}>
                                            <Card sx={{ p: 2, boxShadow: 0, borderRadius: '10px', overflow: "visible" }} className={classes.cardFieldBg}>
                                                <h5 className="title-vt-prodt">BC Sign Off/CP</h5>
                                                <div className="field-wap">
                                                    <label className="txt-label-input">Select Date </label>
                                                    <div className="date-relative-card">
                                                        <Box sx={{ maxWidth: '50%', mb: 2, position: "relative" }}>
                                                            <Controller
                                                                name="bcSignDate"
                                                                control={control}
                                                                render={({ field, fieldState: { error } }) => (
                                                                    <TextField
                                                                        {...field}
                                                                        fullWidth
                                                                        label=""
                                                                        id=""
                                                                        sx={{ input: { backgroundColor: '#fff', borderRadius: "20px" } }}
                                                                        onKeyDown={(e) => e.preventDefault()}
                                                                        error={!!error}
                                                                        helperText={error ? error.message : ""}
                                                                    />
                                                                )}
                                                            />
                                                            <span className={`icon-date ${isDisabled ? 'disabled' : ''}`} onClick={() => toggleCalendar("bcSign")}>
                                                                <i className="fas fa-calendar-alt"></i>
                                                            </span>
                                                            {/* @ts-ignore */}
                                                            {openCalendar === "bcSign" && (<DateCalendarValue dateValue={formData.bcSignDate} onDateSelect={(date) => handleDateSelect(date, "bcSignDate")} onClose={() => setOpenCalendar(null)} />
                                                            )}
                                                        </Box>
                                                    </div>
                                                </div>
                                                <div className="field-wap">
                                                    <label className="txt-label-input">Comment </label>
                                                    <Box sx={{ maxWidth: '100%' }}>
                                                        <TextInput isDisabled={isDisabled} isComment={{ enabled: true, maxLength: 500 }} className="comment-input" onChange={(e) => handleFormChange(e.target.name, e.target.value)} name="bcSignDateComment" label="" control={control} errors={errors} multiline />

                                                    </Box>
                                                </div>
                                            </Card>
                                        </Grid>
                                        <Grid size={{ xs: 12, md: 6 }}>
                                            <Card sx={{ p: 2, boxShadow: 0, borderRadius: '10px', overflow: "visible" }} className={classes.cardFieldBg}>
                                                <h5 className="title-vt-prodt">MPT Product Validation</h5>
                                                <div className="field-wap">
                                                    <label className="txt-label-input">Select Date  </label>
                                                    <div className="date-relative-card">
                                                        <Box sx={{ maxWidth: '50%', mb: 2, position: "relative" }}>
                                                            <Controller
                                                                name="mptProductDate"
                                                                control={control}
                                                                render={({ field, fieldState: { error } }) => (
                                                                    <TextField
                                                                        {...field}
                                                                        fullWidth
                                                                        label=""
                                                                        id=""
                                                                        sx={{ input: { backgroundColor: '#fff', borderRadius: "20px" } }}
                                                                        onKeyDown={(e) => e.preventDefault()}
                                                                        error={!!error}
                                                                        helperText={error ? error.message : ""}
                                                                    />
                                                                )}
                                                            />
                                                            <span className={`icon-date ${isDisabled ? 'disabled' : ''}`} onClick={() => toggleCalendar("mptProduct")}>
                                                                <i className="fas fa-calendar-alt"></i>
                                                            </span>

                                                            {/* @ts-ignore */}
                                                            {openCalendar === "mptProduct" && (<DateCalendarValue dateValue={formData.mptProductDate} onDateSelect={(date) => handleDateSelect(date, "mptProductDate")} onClose={() => setOpenCalendar(null)} />
                                                            )}


                                                        </Box>
                                                    </div>
                                                </div>
                                                <div className="field-wap">
                                                    <label className="txt-label-input">Comment </label>
                                                    <Box sx={{ maxWidth: '100%' }}>
                                                        <TextInput isDisabled={isDisabled} isComment={{ enabled: true, maxLength: 500 }} className="comment-input" onChange={(e) => handleFormChange(e.target.name, e.target.value)} name="mptProductComment" label="" control={control} errors={errors} multiline />

                                                    </Box>
                                                </div>
                                            </Card>
                                        </Grid>
                                        <Grid size={{ xs: 12, md: 6 }}>
                                            <Card sx={{ p: 2, boxShadow: 0, borderRadius: '10px', overflow: "visible" }} className={classes.cardFieldBg}>
                                                <h5 className="title-vt-prodt">First Production</h5>
                                                <div className="field-wap">
                                                    <label className="txt-label-input">Select Date </label>
                                                    <div className="date-relative-card">
                                                        <Box sx={{ maxWidth: '50%', mb: 2, position: "relative" }}>
                                                            <Controller
                                                                name="firstProductionDate"
                                                                control={control}
                                                                render={({ field, fieldState: { error } }) => (
                                                                    <TextField
                                                                        {...field}
                                                                        fullWidth
                                                                        label=""
                                                                        id=""
                                                                        sx={{ input: { backgroundColor: '#fff', borderRadius: "20px" } }}
                                                                        onKeyDown={(e) => e.preventDefault()}
                                                                        error={!!error}
                                                                        helperText={error ? error.message : ""}
                                                                    />
                                                                )}
                                                            />
                                                            <span className={`icon-date ${isDisabled ? 'disabled' : ''}`} onClick={() => toggleCalendar("firstProduction")}>
                                                                <i className="fas fa-calendar-alt"></i>
                                                            </span>
                                                            {/* @ts-ignore */}
                                                            {openCalendar === "firstProduction" && (<DateCalendarValue dateValue={formData.firstProductionDate} onDateSelect={(date) => handleDateSelect(date, "firstProductionDate")} onClose={() => setOpenCalendar(null)} />
                                                            )}
                                                        </Box>
                                                    </div>
                                                </div>
                                                <div className="field-wap">
                                                    <label className="txt-label-input">Comment </label>
                                                    <Box sx={{ maxWidth: '100%' }}>
                                                        <TextInput isDisabled={isDisabled} isComment={{ enabled: true, maxLength: 500 }} className="comment-input" onChange={(e) => handleFormChange(e.target.name, e.target.value)} name="firstProductionComment" label="" control={control} errors={errors} multiline />

                                                    </Box>
                                                </div>
                                            </Card>
                                        </Grid>
                                        <Grid size={{ xs: 12 }}>
                                            <Card sx={{ p: 2, boxShadow: 0, borderRadius: '10px', overflow: "visible" }} className={classes.cardFieldBg}>
                                                <Grid container spacing={2}>

                                                    <Grid size={{ xs: 12, md: 9 }}>
                                                        <div className="field-wap">
                                                            <label className="txt-label-input">Comment </label>
                                                            <Box sx={{ maxWidth: '100%' }}>
                                                                <TextInput isDisabled={isDisabled} isComment={true} className="comment-input" onChange={(e) => handleFormChange(e.target.name, e.target.value)} name="comment" label="" control={control} errors={errors} multiline />

                                                            </Box>
                                                        </div>
                                                    </Grid>

                                                    <Grid size={{ xs: 12, md: 3 }}>
                                                        <label className="txt-label-input">Network Risk </label>
                                                        <div className="project_drpdnw">
                                                            <Controller
                                                                name="risk"
                                                                control={control}
                                                                render={({ field }) => (
                                                                    <SelectDropdown
                                                                        isDisabled={isDisabled}
                                                                        filterKey=""
                                                                        label=""
                                                                        value={field.value}
                                                                        onChange={(val) => {
                                                                            field.onChange(val);
                                                                            handleFormChange("risk", val);
                                                                            // handleFilterChange("risk", val);
                                                                            // clearErrors("risk");
                                                                        }}
                                                                        options={risks}
                                                                        isError={errors.risk ? true : false}

                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                        {errors.risk && <p className="error-message">{errors.risk.message}</p>}
                                                    </Grid>
                                                </Grid>


                                            </Card>
                                        </Grid>
                                    </Grid>
                                </form>
                        }
                    </CardContent>
                </Card>
            </div>
            {/* @ts-ignore */}
            <UnSavedModal close={closeUnSavedModal} saveUnSavedModal={saveUnSavedModal} draftSavedModal={draftSavedModal} discardModal={discardModal} isDraftDisabled={isDraftDisabled} />
            <ValidationModal validationErrors={validationErrors} open={isValidationError} closeValidationModal={closeValidationModal} />
            <AutoSaveModal open={autoSaveModal} closeAutoSave={closeAutoSave} autoSave={autoSave} ></AutoSaveModal>
        </>
    );
};

export default MileStone;

